import { AuthClient } from "../data/auth-client";

async function DeleteUser(userId) {
  try {
    const authClient = new AuthClient();

    const response = await authClient.deleteUser(userId);

    return response;
  } catch (err) {
    console.error("Delete User error", err);
    throw err;
  }
}

export default DeleteUser;
